export default {
  container: {
    opacity: '0',
    animation: '0.6s fadeIn ease-in forwards'
  },
  table: {
    '& th': {
      textAlign: 'left',
      '& span': {
        height: '16px'
      }
    },
    '& td span': {
      height: '16px'
    },
    '& tr:hover td': {
      backgroundColor: 'transparent'
    }
  },
  all: {
    width: '25px'
  },
  allCell: {
    width: '25px'
  },
  receivedCell: {
    width: '115px'
  },
  received: {
    width: '66px'
  },
  conclusionCell: {
    width: '20%',
    textAlign: 'center !important'
  },
  conclusion: {
    width: '42px',
    textAlign: 'center'
  },
  titleCell: {
    width: '20%'
  },
  title: {
    width: '38px'
  },
  lo: {
    width: '135px'
  },
  contextCell: {
    width: '60px'
  },
  center: {
    textAlign: 'center !important'
  },
  bulkAction: {
    display: 'block',
    height: '40px !important',
    width: '93px',
    borderRadius: '4px',
    float: 'right'
  },
  '@keyframes fadeIn': {
    from: { opacity: '0' },
    to: { opacity: '1' }
  }
}
